const formatDateToYYYYMMDD = (dateString: string | null) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toISOString().split('T')[0];
};

export default formatDateToYYYYMMDD;